import { render, staticRenderFns } from "./NotificationClient.vue?vue&type=template&id=1f806aba&scoped=true&"
import script from "./NotificationClient.vue?vue&type=script&lang=js&"
export * from "./NotificationClient.vue?vue&type=script&lang=js&"
import style0 from "./NotificationClient.vue?vue&type=style&index=0&id=1f806aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f806aba",
  null
  
)

export default component.exports